import { createBrowserRouter } from "react-router-dom";
import Main from "../Layouts/Main/Main";
import Home from "../Pages/Homes/Home";
import Contact from "../Pages/Contacts/Contact";
import About from "../Pages/Abouts/About";
import ServicesAll from "../Pages/Services/ServicesAll";
import Team from "../Pages/Teams/Team";
import Motion from "../Pages/Services/Content/Motion";
import Photography from "../Pages/Services/Photography/Photography";
import Printing from "../Pages/Services/Printing/Printing";
import Brand from "../Pages/Services/Brand/Brand";
import Kavan from "../Pages/Services/Brand/BrandShow/Kavan";
import Gazi from "../Pages/Services/Brand/BrandShow/Gazi";

const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/about',
                element: <About></About>
            },
            {
                path: '/service',
                element: <ServicesAll></ServicesAll>
            },
            {
                path: '/portfolio',
                element: <Motion></Motion>
            },
            {
                path: '/team',
                element: <Team></Team>
            },
            {
                path: '/contact',
                element: <Contact></Contact>
            },
            {
                path: '/photo',
                element: <Photography></Photography>
            },
            {
                path: '/print',
                element: <Printing></Printing>
            },
            {
                path: '/brand',
                element: <Brand></Brand>
            },
            {
                path: '/kavan',
                element: <Kavan></Kavan>
            },
            {
                path: '/gazi',
                element: <Gazi></Gazi>
            }

        ]
    }
]);
export default router
    ;